import { Github, Linkedin } from "lucide-react";

export const socialLinks = [
    {
      name: "GitHub",
      url: "https://github.com/matin808",
      icon: <Github />, // You can use react-icons
    },
    {
      name: "LinkedIn",
      url: "https://www.linkedin.com/in/abdul-matin-kadri-b129831a1/",
      icon: <Linkedin />,
    },
    // Add more social links
  ];